export const BASE_TITLE = "匯融科技 | ";
export const CONTACT_ADDRESSEE = "julianlee@websoft.com.tw";
export const EMAIL_FORMAT = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;